export const EVENT_NAMES = {
  FORM_INPUT_FOCUS: 'form_input_focus',
  FORM_SUBMIT_STATUS: 'form_submit_status',
  TRACK_USER: 'track_user',
  REGISTER_USER: 'register_user',
  LOGOUT: 'logout',
  MODAL_CHANGE: 'modal_change',
  PAGE_LOAD: 'we_page_load',
  PAYMENT: 'payment',
  VERTICAL_SCROLL: 'scroll_vertical',
  HORIZONTAL_SCROLL: 'scroll_horizontal',
  USER_DETAILS_FILLED: 'user_details_filled',
  SET_USER_ATTRIBUTE: 'set_user_attribute',
  LEAD_FORM_ATTRIBUTION: 'lead_form_attribution',
};

export const ELEMENT_TYPES = {
  CTA: 'cta',
  FORM_SUBMIT: 'form_submit',
  FORM_INPUT: 'form_input',
};

export const PARAMS_CONSTANTS = [
  'utm_source', 'utm_medium', 'utm_content',
  'utm_campaign', 'utm_term',
  'param1', 'param2', 'param3',
  'param4', 'param5',
];

export const CLICK_PARAMS = ['gclid', 'fbclid', 'msclkid'];

export const PRODUCTS = {
  EDGE: 'edge',
  ACADEMY: 'academy',
  PLUS: 'plus',
  CONTESTS: 'contests',
  SAT: 'selfassessment',
  CODEX: 'codex',
  EVENTS: 'events',
  DRONA: 'drona',
  DATA_SCIENCE: 'data_science',
  REVIEW: 'alumni_directory',
};

export const SKIP_SNAKE_CASE = [
  EVENT_NAMES.PAGE_LOAD,
];

export const DATE_ATTRIBUTES = [
  'end_time',
  'start_time',
];

export const PHONE_ATTRIBUTES = [
  'we_phone',
  'phone_number',
];

export const GTM_FALLBACK_API = {
  method: 'POST',
  endpoint: '/api/v3/analytics/tracking/gtm/track',
};
